module.exports = __webpack_public_path__ + "img/electronic_payment1.3a39f01f.jpeg";